export class NumberHelper {
    // Keep 2 removes digits from an amount
    // It doesn't round up numbers
    // ex: keep2(2.59999) => 2.59
   
    // For some floats values the multiplication results are not the desired ones 
    // ex: For (541.31 * 100) javascript returns 54130.99999999999, not 54131
    // Which causes one cents amounts balances
    // Adding Math.round() to the multiplication result will resolve this issue.
    static keep2(n: number): number{
        return Math.floor(Math.round(n * 100)) / 100
    }
}

export default NumberHelper



// WEBPACK FOOTER //
// ./src/state/helpers/NumberHelper.ts